module.exports = __webpack_public_path__ + "img/236.9159f66f.png";